import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Copyright Medwag &copy; 2019</span>
      </footer>
    );
  }
;

export default Footer;
